import DragSortingTable from './DragSortingTable';

export default DragSortingTable;
